import script from "./AdminPartners.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPartners.vue?vue&type=script&setup=true&lang=js"

import "./AdminPartners.vue?vue&type=style&index=0&id=d6124b38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6124b38"]])

export default __exports__